// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2lp-Q","inner":"Form_inner__2SUKH","range":"Form_range__2wmG4","name":"Form_name__wJZ0s","actions":"Form_actions__3vCek"};